import { memo } from "react";
import { Modal, Button } from "antd";
import IntlMessages from "../Message/IntlMessages";
import { ErrorType } from "const";
import { useHistory } from "react-router-dom";

const SubscriptionProblemModal = ({
  code, close, state, actions, ...modalProps
}) => {

  const history = useHistory()

  function _onAccept() {
    close();
    actions?.onEdit && actions.onEdit();
  }

  function _onCancel() {
    close();
    history.goBack()
  }

  function isNotEnoughCase() {
    return code === ErrorType.SETTLE_REMAIN_NOT_ENOUGH
      || code === ErrorType.CBS_REMAIN_NOT_ENOUGH
      || code === ErrorType.REF_PRICING_NOT_MATCH
      || code === ErrorType.CHANNAL_STATUS_NOT_MATCH
  }
  
  return (
    <Modal {...modalProps} maskClosable={false} onCancel={close}>
      {modalProps.visible && (
        <div className="mnc-modal-disclaimer" >
          <div className="modal-mnc-head">
            <h5 className="m-0">
              <IntlMessages id="modal.disclaimer.header.subscription-problem" />
            </h5>
            <Button className="btn button-ktb-close ms-auto" onClick={_onCancel}>
              <i className="feather-icon icon-x"></i>
            </Button>
          </div>
          <div className="modal-mnc-body" style={{
            whiteSpace: "pre-wrap",
            overflowX: "auto",
          }} >
            
            <p className="text-center">{state.message}</p>
          </div>
          <div className="modal-mnc-footer">
            <div className="row justify-content-center">
              <div className="col-6 pe-1 pe-md-2">
                <div className="d-grid">
                  <Button
                    data-logout-btn
                    className="btn button-ktb-line"
                    onClick={_onCancel}
                  >
                    {isNotEnoughCase()
                      ? <IntlMessages id="global.cancel" />
                      : <IntlMessages id="global.close" />}
                  </Button>
                </div>
              </div>
              {isNotEnoughCase() && (
                <div className="col-6 ps-1 ps-md-2">
                  <div className="d-grid">
                    <Button
                      data-accept-btn
                      className="btn button-ktb-main"
                      onClick={_onAccept}
                    >
                      {code === ErrorType.REF_PRICING_NOT_MATCH || code === ErrorType.CHANNAL_STATUS_NOT_MATCH
                      ? <IntlMessages id="global.transaction.agine" /> 
                      : <IntlMessages id="global.edit" />}
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </Modal>
  );
};

export default memo(SubscriptionProblemModal);
